<template>
	<section class="hero-panel">
		<div class="hero-panel__glow hero-panel__glow--left"></div>
		<div class="hero-panel__glow hero-panel__glow--right"></div>

		<div class="hero-panel__top">
			<button class="back-button" type="button" @click="$emit('back')">
				<i class="el-icon-back back-button__icon"></i>
			</button>

			<div class="hero-title">
				<div class="hero-title__line">
					<h1>调压器详情</h1>
					<span :class="['status-pill', statusClass]">{{ pageStatus }}</span>
				</div>
				<p>{{ pageMeta }}</p>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'DetailsHeroPanel',
	props: {
		pageStatus: {
			type: String,
			default: '',
		},
		pageMeta: {
			type: String,
			default: '',
		},
	},
	computed: {
		statusClass() {
			return this.pageStatus === '运行正常' ? 'status-pill--success' : 'status-pill--warning'
		},
	},
}
</script>

<style lang="scss" scoped>
.hero-panel {
	position: relative;
	overflow: hidden;
	padding: 24px 28px 22px;
	border: 1px solid var(--panel-border);
	border-radius: 12px;
	backdrop-filter: blur(12px);
	background: linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 255, 0.94)), var(--panel-bg);
	flex-shrink: 0;
}

.hero-panel__glow {
	position: absolute;
	width: 280px;
	height: 280px;
	border-radius: 50%;
	filter: blur(18px);
	opacity: 0.25;
	pointer-events: none;
}

.hero-panel__glow--left {
	left: -120px;
	top: -120px;
	background: rgba(37, 99, 235, 0.22);
}

.hero-panel__glow--right {
	right: -100px;
	top: -120px;
	background: rgba(14, 165, 233, 0.22);
}

.hero-panel__top {
	position: relative;
	display: flex;
	align-items: center;
	gap: 16px;
}

.back-button {
	width: 42px;
	height: 42px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	padding: 0;
	border: 1px solid #d7e1ea;
	border-radius: 999px;
	background: rgba(255, 255, 255, 0.92);
	color: #334155;
	cursor: pointer;
	transition: all 0.2s ease;
}

.back-button:hover {
	border-color: #bfd4ff;
	background: #f8fbff;
	transform: translateY(-1px);
}

.back-button__icon {
	font-size: 16px;
	color: #334155;
	line-height: 1;
}

.hero-title {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.hero-title__line {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px;
}

.hero-title h1 {
	margin: 0;
	color: var(--title);
	font-size: 22px;
	font-weight: 700;
	letter-spacing: 0.01em;
}

.hero-title p {
	margin: 0;
	font-size: 14px;
	line-height: 1.6;
	color: var(--muted);
}

.status-pill {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-height: 24px;
	padding: 2px 10px;
	border-radius: 999px;
	font-size: 12px;
	font-weight: 700;
	white-space: nowrap;
}

.status-pill--warning {
	background: var(--warning-soft);
	color: var(--warning);
}

.status-pill--success {
	background: var(--success-soft);
	color: var(--success);
}

@media (max-width: 1240px) {
	.hero-title h1 {
		font-size: 22px;
	}
}

@media (max-width: 900px) {
	.hero-panel__top {
		flex-direction: row;
		align-items: flex-start;
	}
}
</style>
